import { Controller } from "stimulus"

// Client-side search for the Import Center catalogue: filters object cards by
// name/description, hides groups left empty, and toggles the empty state.
export default class extends Controller {
  static targets = ["search", "group", "object", "empty"]

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    let anyVisible = false

    this.objectTargets.forEach(card => {
      const match = query === "" || (card.dataset.search || "").includes(query)
      card.classList.toggle("hidden", !match)
      if (match) anyVisible = true
    })

    this.groupTargets.forEach(group => {
      const visible = group.querySelectorAll('[data-import-center-target="object"]:not(.hidden)').length
      group.classList.toggle("hidden", visible === 0)
    })

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", anyVisible)
  }
}
